import React from "react";
const SearchContext = React.createContext(null);
export default SearchContext;
